import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Device } from 'src/app/models/device.model';

@Component({
  selector: 'app-move-device-dialog',
  templateUrl: './move-device-dialog.component.html',
  styleUrls: ['./move-device-dialog.component.scss']
})
export class MoveDeviceDialogComponent {
  // selectedEnvironment: string = '';

  // allEnvironments = [
  //   { code: 'dev', description: 'Development' },
  //   { code: 'qa', description: 'QA' },
  //   { code: 'prod', description: 'Production' }
  // ];

  // get environments() {
  //   return this.allEnvironments.filter(env => env.code !== this.data.device.env);
  // }

  // constructor(
  //   public dialogRef: MatDialogRef<MoveDeviceDialogComponent>,
  //   @Inject(MAT_DIALOG_DATA) public data: { device: Device }
  // ) {}

  // onCancel(): void {
  //   this.dialogRef.close();
  // }

  // onConfirm(): void {
  //   if (!this.selectedEnvironment) return;
  //   this.dialogRef.close(this.selectedEnvironment);
  // }
} 